/*
 * @Author: qian.tang
 * @Date: 2022-12-08 16:36:14
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2022-12-21 09:52:59
 * @FilePath: \itrazo-portal-dev\src\statics\images\index.tsx
 * @Description:
 *
 * Copyright (c) 2022 by Qian Tang qian@itrazotracetech.com, All Rights Reserved.
 */
import failureAlert from "./failureAlert.svg";
import temp from "./temp.svg";
import diversion from "./diversion.svg";
import noActivity from "./noActivity.svg";
import counter from "./counter.svg";
import boundary from "./boundaryicon.svg";
import valueAlert from "./valueAlert.svg";
import editColumn from "./edit-column.svg";
import { ALERTS_TYPES, ALLOCATION_TYPES, ASSET_ALERTS_TYPES, ASSET_MAINTENANCE_TYPES } from "../../utilities/CONSTANTS";

import newInsight from "./newInsight.svg";
import greyInsight from "./greyInsight.svg";
import insightActive from "./insightActive.svg";
import newAssest from "./newAssest.svg";
import greyAsset from "./greyAsset.svg";
import assetActive from "./assetActive.svg";
import amActive from "./amActive.svg";
import amInactive from "./amInactive.svg";
import inventory from "./inventory.svg";
import greyInventory from "./greyInventory.svg";
import inventoryActive from "./inventoryActive.svg";
import inventoryProd from "./inventoryProd.svg";
import inventoryProdActive from "./inventoryProdActive.svg";
import biUsers from "./biUsers.svg";
import greyUser from "./greyUser.svg";
import greyVisitor from "./greyVisitor.svg";
import visitorIconActive from "./visitorIconActive.svg";
import greyCrm from "./greyCrm.svg";
import biUsersActive from "./biUsersActive.svg";
import crmActive from "./crmActive.svg";
import crmInactive from "./crmInactive.svg";
import UserIcon from "./userIcon.svg";
import userIconActive from "./userIconActive.svg";
import valueChainIcon from "./valueChainIcon.svg";
import greyValueChain from "./greyValueChain.svg";
import valueChainIconActive from "./valueChainIconActive.svg";
import consumer from "./consumer.svg";
import greyConsumerEngagement from "./greyConsumerEngagement.svg";
import consumerActive from "./consumerActive.svg";
import cmsActive from "./cmsActive.svg";
import cmsInactive from "./cmsInactive.svg";


const STATIC_IMAGES = {
  ALERT_ICONS: {
    [ALERTS_TYPES[0]]: failureAlert,
    [ALERTS_TYPES[1]]: temp,
    [ALERTS_TYPES[2]]: diversion,
  },
  ASSET_ALERT_ICONS: {
    [ASSET_ALERTS_TYPES["LOCATION DIVERT"]]: diversion,
    [ASSET_ALERTS_TYPES["TEMPERATURE"]]: temp,
    [ASSET_ALERTS_TYPES["GEOFENCE BREACH"]]: boundary,
    [ASSET_ALERTS_TYPES["HUMIDITY"]]: counter,
    [ASSET_ALERTS_TYPES["OTHER"]]: valueAlert,
  },
  ALLOCATION_ICONS: {
    [ALLOCATION_TYPES["ASSETS AVAILABLE"]]: diversion,
    [ALLOCATION_TYPES["ALLOCATED"]]: temp,
    [ALLOCATION_TYPES["IN MAINTENANCE"]]: boundary,
    [ALLOCATION_TYPES["TOTAL"]]: counter,
  },
  ASSET_MAINTENANCE_ICONS: {
    // [ASSET_MAINTENANCE_TYPES["OVERDUE"]]: temp,
    // [ASSET_MAINTENANCE_TYPES["UPCOMING"]]: boundary,
    // [ASSET_MAINTENANCE_TYPES["COMPLETED"]]: counter,
    [ASSET_MAINTENANCE_TYPES.DUE]: temp,
    [ASSET_MAINTENANCE_TYPES.COMPLETED]: counter,
  },
  EDIT_COLUMN: editColumn,
  SIDE_BAR_ICONS: {
    insight: {
      // inactive: newInsight, //White Icon
      inactive: greyInsight,
      active: insightActive
    },
    asset: {
      // inactive: newAssest, // White Icon
      inactive: amInactive,
      active: amActive
    },
    inventory: {
      // inactive: inventory, // White Icon
      inactive: greyInventory,
      active: inventoryActive
    },
    inventoryProduction: {
      inactive: inventoryProd,
      active: inventoryProdActive
    },
    vistorManagement: {
      inactive: greyVisitor,
      active: visitorIconActive,
    },
    crm: {
      // inactive: biUsers, // White Icon
      inactive: crmInactive,
      active: crmActive
    },
    cms: {
      inactive: cmsInactive,
      active: cmsActive
    },
    admin: {
      // inactive: UserIcon, // White Icon
      inactive: greyUser,
      active: userIconActive
    },
    valueChain: {
      // inactive: valueChainIcon, // White Icon
      inactive: greyValueChain,
      active: valueChainIconActive
    },
    consumer: {
      // inactive: consumer, // White Icon
      inactive: greyConsumerEngagement,
      active: consumerActive
    }
  }
};

export default STATIC_IMAGES;
